import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
const ClinicApproval = () => {
    const [searchParams] = useSearchParams();
    const status = searchParams.get('status');
    let heading = '';
    let message = '';
    let isError = false;
    switch (status) {
        case 'approved':
            heading = '✅ Success';
            message = 'This clinic has been approved.';
            break;
        case 'rejected':
            heading = '❌ Rejected';
            message = 'This clinic request has been rejected.';
            isError = true;
            break;
        case 'notfound':
            heading = '❌ Not Found';
            message = 'No user found for this request.';
            isError = true;
            break;
        case 'invalid':
            heading = '❌ Invalid';
            message = 'Invalid approval action.';
            isError = true;
            break;
        case 'error':
            heading = '❌ Error';
            message = 'Something went wrong.';
            isError = true;
            break;
        default:
            heading = '❌ Unknown';
            message = 'Unknown status.';
            isError = true;
    }
    return (_jsxs("div", { style: { padding: '2rem', textAlign: 'center' }, children: [_jsx("h2", { children: heading }), _jsx("p", { children: message })] }));
};
export default ClinicApproval;
